import * as React from "react";
import { forwardRef } from "react";
const SvgArchive = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m9 15 4-4-1.4-1.4-1.6 1.6V7H8v4.2L6.4 9.6 5 11zm-7 3q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 16V3.525q0-.35.113-.675t.337-.6L1.7.725q.274-.35.687-.538.412-.188.863-.187h11.5q.45 0 .863.188.413.187.687.537l1.25 1.525q.225.275.338.6t.112.675V16q0 .825-.587 1.413A1.92 1.92 0 0 1 16 18zm.4-15h13.2l-.85-1H3.25z" }));
const ForwardRef = forwardRef(SvgArchive);
export default ForwardRef;
